import React, { useRef, useEffect, useCallback, useState } from 'react'
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageToggle from '../components/LanguageToggle'
import TnCPopup from '../components/TnCPopup';
import MenuPopup from '../components/MenuPopup';

function ContactUsScreen() {
  const language = localStorage.getItem("appLanguage") || "en";
  const { t } = useTranslation();
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <link rel="shortcut icon" href="assets/images/favicon.ico" type="image/x-icon" />
      <link rel="stylesheet" href="https://use.typekit.net/hiu4ulc.css" />
      <link rel="stylesheet" href="assets/css/styles.css?ver=2.6" />
      <title>CONTACT US | Britannia</title>
      <div className="page-wrapper">
        <div className="main-wrapper yellow-bg">
          {/*=============== DESKTOP SCREEN START ===============*/}
          <div className="d-frame-outer desktop-only">
            <img src="assets/images/desktop-star.webp" className="d-frame-star-bg" />
            <span className="d-frame-corner tl" />
            <span className="d-frame-corner tr" />
            <span className="d-frame-corner bl" />
            <span className="d-frame-corner br" />
            <div className="d-frame-border-outer">
              <div className="d-frame-border">
                <div className="d-frame-border-inner">
                  <div className="d-frame-canvas">
                    <div className="d-frame-content">
                      <div className="desktop-center">
                        <div className="desktop-content-box">
                          <h3>Thank you for your interest in participating in the</h3>
                          <img
                            src="assets/images/desktop-logo-milk-bikis.webp"
                            className="desktop-logo"
                            alt="Milk Bikis Logo"
                          />
                          <div className="desktop-qr-box">
                            <span className="qr-corner qr-corner-tl" />
                            <span className="qr-corner qr-corner-tr" />
                            <span className="qr-corner qr-corner-bl" />
                            <span className="qr-corner qr-corner-br" />
                            <div className="qr-left">
                              <p className="qr-text">
                                Please scan the QR code on your phone to enter the experience :
                              </p>
                            </div>
                            <div className="qr-right">
                              <img src="assets/images/desktop-qr.svg" alt="QR Code" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*=============== DESKTOP SCREEN END ===============*/}

          {/* ══ PERSISTENT FRAME ══ */}
          <div className="frame-outer mobile-only">
            <span className="frame-corner tl" />
            <span className="frame-corner tr" />
            <span className="frame-corner bl" />
            <span className="frame-corner br" />
            <div className="frame-border-outer">
              <div className="frame-border">
                <div className="frame-border-inner">
                  <div className="frame-canvas">
                    <div className="frame-content">


                      {/* REWARD SCREEN START */}
                      <div className="kural-screen rwd-screen">

                        {/* TOP */}
                        <div className="kural-top">
                          <div className="kural-head-container">
                            <div className="logo-head">
                              <div className="camera-sc-logo-wrap">
                                <img src="assets/images/animate-britania-logo.webp" alt="Britannia" className="camera-sc-logo camera-sc-logo-1" />

                                <img src="assets/images/animate-milk-bikkis-logo.webp" alt="Milk Bikis" className="camera-sc-logo camera-sc-logo-2" />
                              </div>
                              <img src="assets/images/sign-up-head-text.webp" className="top-logo-text" alt="Top Logo" onClick={() => navigate("/home")} />

                              <div className="menu-bars" onClick={() => navigate("/menu")}>
                                <span></span>
                                <span></span>
                                <span></span>
                              </div>
                            </div>
                            {/* <LanguageToggle /> */}
                          </div>
                        </div>

                        {/* CENTER */}
                        <div className="menu-popup-container">
                          <div className="menu-popup-content">
                            <div className="menu-popup-header">
                              <img style={{
                                width: "220px"
                              }} src={language === "ta" ? "assets/images/contact-us-text-tamil.webp" : "assets/images/contact-us-text.webp"} className="menu-popup-icon" alt="Menu Icon" />
                            </div>

                            <div className="menu-popup-body-wrapper">
                              <div className="menu-popup-body">
                                <p style={{ whiteSpace: "pre-line", textAlign: "center" }}>
                                  <b>{t("contactUs.needAssistance")}</b>{"\n"}
                                  {t("contactUs.emailUs")}{"\n"}{"\n"}
                                  <a style={{ color: "#000000"}} href="mailto:feedback@britindia.com">
                                    {t("contactUs.email")}
                                  </a>{"\n"}{"\n"}
                                  <b>{t("contactUs.getBack")}</b>
                                </p>
                              </div>

                              {/* <button className="btn-next menu-btn" type="button" onClick={() => navigate(-1)}>
                                <span>Go back</span>
                              </button> */}
                            </div>
                            <button onClick={() => navigate(-1)}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                                padding: "8px 0px",
                              }}
                              className="kp-rwd-btn">
                              <span style={{ fontSize: language == "ta" ? "13px" : "17px" }}>{t("common.goBack")}</span>
                            </button>
                          </div>
                        </div>


                        {/* BOTTOM STRIP */}
                        <div className="kural-bottom">
                          <div className="kural-steps">
                            <span style={{ fontSize: language === "ta" ? "6px" : "8px" }}>{t("dashboard.scanStep")}</span>
                            <img src="assets/images/right-arrow-icon.webp" alt="arrow" className="arrow-img" />
                            <span style={{ fontSize: language === "ta" ? "6px" : "8px" }}>{t("dashboard.completeStep")}</span>
                            <img src="assets/images/right-arrow-icon.webp" alt="arrow" className="arrow-img" />
                            <span style={{ fontSize: language === "ta" ? "6px" : "8px" }}>{t("dashboard.sendVideoStep")}</span>
                          </div>
                        </div>

                      </div>
                      {/* REWARD SCREEN END */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /frame-outer */}
        </div>
      </div>
    </>
  )
}

export default ContactUsScreen
